module.exports = __webpack_public_path__ + "img/high-bg.62f2e194.png";